<template>
	<div class="header-box flex flex_jus_between">
		<div class="header flex flex_jus_between">
            <p class="title">NEWSFLOW</p>
            <p class="time">{{timeView}}</p>
        </div>
        <!-- <div class="header flex flex_jus_between">
            <div class="pliicy hover-time">PRIVACY PLIICY</div>
            <p>ABOUT</p>
        </div> -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			timeView: ''
		}
	},
	computed: {},
    methods: {
        loadTime() {
            let _this = this;
            setInterval(function(){
                let time=new Date();
                let year=time.getFullYear(); //获取年份
                let month=time.getMonth()+1; //获取月份
                let day=time.getDate();  //获取日期
                let hour=checkTime(time.getHours());  //获取时
                let minite=checkTime(time.getMinutes()); //获取分
                let second=checkTime(time.getSeconds()); //获取秒
                /****当时、分、秒、小于10时，则添加0****/
                function checkTime(i){
                    if(i<10) return "0"+i;
                    return i;
                }
                _this.timeView = year+"-"+month+"-"+day+"- "+hour+":"+minite+":"+second;
            },1000)
        }
    },
    mounted() {
        this.loadTime();
    }
}
</script>


<style scoped>
.header-box {
    width: 100%;
}
.header {
    padding: .1rem 0.2rem;
}
.title {
    display: flex;
    align-items: center;
    font-family: DolceVitaHeavy-Bold;
    font-size: .15rem;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 700;  
}
.time {
    display: flex;
    align-items: center;
    font-family: DolceVitaHeavy-Bold;
    font-size: .1rem;
    color: #9DA2E8;
    letter-spacing: 0;
    font-weight: 700;
    margin-left: 0.1rem;
}
.pliicy {
    cursor: pointer;
    font-family: DolceVitaHeavy-Bold;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    font-weight: 700;
    font-size: .1rem;
    padding: 0.05rem;
    background-image: linear-gradient(137deg, #ED4D8B 0%, #F05B4A 100%);
    border-radius: 26.5px;
    margin-right: 0.1rem;
}
.pliicy:hover{
    transform: scale(1.2); /* 鼠标放到图片上的时候图片按比例放大0.5倍   */
}
</style>


// WEBPACK FOOTER //
// src/components/modules/Header.vue